var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectUser',{attrs:{"isRadio":_vm.selectOptions.isRadio,"isNeedSearch":_vm.selectOptions.isNeedSearch,"title":_vm.selectOptions.title,"userList":_vm.userList},on:{"search":_vm.handleSearch,"complete":_vm.handleSelectedResult}})}
var staticRenderFns = []

export { render, staticRenderFns }